module.exports = __webpack_public_path__ + "1f5e90d6c5d76ae83b22b9747855943d.png";